export var REACT_APP_DJANGO_ADMIN_URL = process.env.REACT_APP_DJANGO_ADMIN_URL || 'https://manage.bishkek.events/admin/';
export var REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://manage.bishkek.events/api/';
export var REACT_APP_WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://bishkek.events/';
